export const PASSWORD_MANAGER_IGNORE_INPUT_PROPS = {
  autocomplete: 'off',
  'data-1p-ignore': '',
  'data-lpignore': 'true',
  'data-bwignore': '',
  'data-form-type': 'other',
} as const

export const PASSWORD_MANAGER_IGNORE_CONTAINER_PROPS = {
  autocomplete: 'off',
  'data-1p-ignore': '',
  'data-lpignore': 'true',
  'data-bwignore': '',
} as const

const FORM_FIELD_SELECTOR = 'input, textarea, select'

export const applyPasswordManagerIgnoreToElement = (element: Element) => {
  if (!(element instanceof HTMLElement)) {
    return
  }

  Object.entries(PASSWORD_MANAGER_IGNORE_INPUT_PROPS).forEach(
    ([key, value]) => {
      element.setAttribute(key, value)
    }
  )

  if (element instanceof HTMLInputElement && element.type === 'email') {
    element.type = 'text'
    element.setAttribute('inputmode', 'email')
  }
}

export const applyPasswordManagerIgnoreToSubtree = (root: ParentNode) => {
  if (root instanceof HTMLElement) {
    applyPasswordManagerIgnoreToElement(root)
  }

  root
    .querySelectorAll(FORM_FIELD_SELECTOR)
    .forEach(applyPasswordManagerIgnoreToElement)
}
